export const returnableQty = (line) =>
  Math.max(0, line.quantity - (line.returnedQty || 0))

export const clampReturnQty = (value, line) =>
  Math.max(0, Math.min(returnableQty(line), Math.trunc(Number(value) || 0)))

const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100

// Mirrors the server's refund math so the cashier sees the amount before confirming
export const refundPreview = (sale, picks) => {
  const subtotal = round2(
    sale.items.reduce(
      (sum, line) =>
        sum + round2(line.discprice * (picks[line.inventory] || 0)),
      0
    )
  )
  const taxes = round2(
    sale.items.reduce(
      (sum, line) =>
        sum +
        round2(
          (round2(line.discprice * (picks[line.inventory] || 0)) *
            sale.taxrate) /
            100
        ),
      0
    )
  )

  return { subtotal, taxes, total: round2(subtotal + taxes) }
}

export const buildReturnItems = (picks) =>
  Object.entries(picks)
    .filter(([, quantity]) => quantity > 0)
    .map(([inventory, quantity]) => ({ inventory, quantity }))
